import React, { FC } from "react";

type Props = Record<string, never>;
const CorpAnimeFurusatoTerms: FC<Props> = () => {
  return (
    <>
      <section>
        <h1>
          <span style={{ display: "inline-block" }}>企業版アニメふるさと納税</span>
          <span style={{ display: "inline-block" }}>に関する特約</span>
        </h1>
      </section>
      <section>
        <p>
          本特約は、当社が運営する「アニメファンド」を通じて提供されるサービス「企業版アニメふるさと納税」の利用条件を定めるものです（以下「本特約」といいます）。
          企業版アニメふるさと納税の利用にあたっては、アニメファンド利用規約（以下「原規約」といいます）に加えて、本特約のすべてに同意いただく必要があります。
          また、企業版アニメふるさと納税の利用により、会員は、本特約及びが利用するサービスごとに定められたガイドラインや注意事項に同意したものとみなされます。
        </p>
      </section>
      <section>
        <h4>第１条（定義）</h4>
        <p>本特約において用いる用語の定義は次の通りとします。</p>
        <ul>
          {[
            {
              name: "企業版アニメふるさと納税",
              description: "本サービスのうち、地方公共団体へ企業が寄附することを可能にするサービス",
            },
            {
              name: "企業",
              description:
                "本サービスを利用して、特定の自治体に対して金銭を寄附する、寄附した、または寄附を検討している企業等(NPO法人を含みます。)",
            },
          ].map((definition, index) => (
            <li key={index}>
              （{index + 1}）「{definition.name}」
              <br />
              {definition.description}
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h4>第２条（プロジェクトの類型と成立）</h4>
        <p>プロジェクトは、集まった寄附金の中で自治体ごとの「まち・ひと・しごと創生寄附活用事業」に活用します。</p>
      </section>
      <section>
        <h4>第３条（税務手続き）</h4>
        <p>
          <strong>１項</strong>
          企業は、応援に関連して税控除を受ける場合はかかる手続きを自己の責任で行うものとし、当社はかかる手続きに関しいかなる責任も負わないものとします。
        </p>
        <p>
          <strong>２項</strong>
          企業による寄附金の支払いは、次条に定める寄附金の決済方法によるものとします。
        </p>
        <p>
          <strong>３項</strong>
          企業は、本サイトを通じて自治体に対して行う寄附について、以下のとおり決済方法に応じて定める時点以降、当該寄附を撤回することはできません。当該寄附の取扱いは、直接、寄附先の自治体にお問い合わせください。
          <table className="temporary">
            <tbody>
              <tr>
                <th>口座振込</th>
                <td>企業が指定口座に向けて送金をした時点</td>
              </tr>
            </tbody>
          </table>
        </p>
        <p>
          <strong>４項</strong>
          企業は、自治体が本サイトを通じて企業から申し込まれた寄附について、当該自治体が定める一定の基準に従いその受領を拒絶しまたは返金することがあることを予め了承するものとします。それに伴う返金手続きは、企業と自治体間で直接協議するものとします。自治体は、当該基準および受領拒絶等の理由を企業に開示する義務を負いません。また、アニメファンドは、自治体による寄附の受領拒絶等について一切責任を負わないものとします。
        </p>
        <p>
          <strong>５項</strong>
          企業が、本サイトを通じて自治体に対して寄附の申込みをした後、最初に到来する3月末日まで(但し、1月1日から3月末日までの間に申し込まれた寄附については、申込日の翌年の3月末日まで)に決済完了に至らない場合、当該時点においてかかる寄附の申込みは撤回されたものとみなされます。なお、決済が完了した場合、企業に対して決済完了の通知がなされます。
        </p>
      </section>
      <section>
        <h4>第４条（寄附の方法）</h4>
        <p>
          企業が本サイトを通じて寄附を行う場合、本サイト上の画面または本サイトから遷移する画面に表示される所定の情報を入力するものとします。
        </p>
      </section>
      <section>
        <h4>第５条（寄附金の決済方法）</h4>
        <p>
          <strong>１項</strong>
          企業は、以下のいずれかの決済方法(以下「本決済方法」といいます。）により寄附を行うことができます。ただし、寄附を行う時点で、決済方法を選択する画面において表示される方法に限られるものとします。
        </p>
        <ul>
          <li>（１）口座振込(支払先口座は寄附申込みの受付確認の通知(メール、マイページ上の通知、その他の電磁的方法によるものとします。)に表示される口座に限ります。)</li>
        </ul>
        <p>
          <strong>２項</strong>
          企業は、寄附先の自治体が指定した指定代理納付者（自治体がアニメファンドを指定納付受託者に指定した場合には指定納付受託者と読み替えます。）であるアニメファンドに対し、自治体に対する寄附金の納付を委託します。
        </p>
        <p>
          <strong>３項</strong>
          企業は、自らが選択した本決済方法に応じて本サイト上で要求される所定の情報すべてについて、正確かつ漏れなく入力するものとします。
        </p>
        <p>
          <strong>４項</strong>
          企業は、自己が選択した本決済方法において支払期日の指定がある場合には、当該支払期日までに決済を完了させるものとします。
        </p>
        <p>
          <strong>５項</strong>企業が対応する支払先口座において寄附金が受領された時点をもって納付がなされたものとします。
        </p>
        <p>
          <strong>６項</strong>
          企業が、振込用紙の記載ミス等により意図したよりも多い金額を本決済方法により決済してしまった場合であっても、アニメファンドは、本決済方法により一旦収納した寄附金を、自治体に引き渡すものとし、企業に返金する義務を負わないものとします。企業は、かかる寄附金の取扱いについては、当該自治体と直接協議するものとします。
        </p>
        <p>
          <strong>７項</strong>
          寄附金の受領証の発行は、自治体がその責任において行うことを確認するとともに、寄附金の受領証の発行時期の希望がある場合、自治体と直接協議するものとします。
        </p>
      </section>
      <section>
        <h4>第６条（適用）</h4>
        <p>本特約は、原規約に優先して適用されるものとします。また、本特約に定めのない事項は、原規約の定めに従うものとします。</p>
      </section>
    </>
  );
}
export default CorpAnimeFurusatoTerms;
